export const changeRouteOne = (route, wait, props) => {
  window.scrollTo(0, 0);
  document.body.style.overflow = "hidden";

  //before pushing it will wait 600ms
  setTimeout(() => props.history.push(route), wait);
};

export const pageDataArr = [
  {
    introTitle: "INTRO",
    introHead:
      " Hi there! I am Wasiq Abdullah. A Full Stack Developer having specialization in Web Development.",
    introDesc:
      " I mainly use Adobe XD or Figma to design UI/UX. And then MERN Stack to convert it to a real Web or Mobile App. I also rely on other helper libraries in order to create a better User Experience.",
  },
  {
    introTitle: "ABOUT ME",
    introHead:
      "Hey! I am a Full time Freelancer. I have 3+ years of experience in Web & Mobile App Development.",
    introDesc:
      "The main area of my expertise is Web Development. I can design and develop slick, Interactive, Responsive and Performance Efficient Web & Mobile Applications. I also have some experience of creating websites on CMS like Wordpress.",
  },
  {
    introTitle: "DESIGN",
    introHead:
      "I love to design experiences that not only complete the functional value but also loved by people.",
    introDesc:
      "I also have expertise in UX Design & currently working as a Full Time Freelance UX Designer. I believe great design is defined by the experience it creates for the User combined with flawless execution. I'm a designer with a keen eye for creating engaging UI, bringing products to life. ",
  },
  {
    introTitle: "DEVELOP",
    introHead:
      "I'm an ingenious Programmer oriented to the Web Development, I lead and design products that people love.",
    introDesc:
      "I mostly rely on MERN Stack in order to develop Web and Mobile Applications. I try to bring unique prespective of designer & developer. I am currently Learning Data Science.",
  },
];
